import { Dialog } from '@hai/ui-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onSave?: VoidFunction;
  onReboot?: VoidFunction;
  onCancel?: VoidFunction;
  bodyText?: string;
}

export const RebootNeededNotSavedModal: React.FunctionComponent<Props> = ({ onSave, onReboot, onCancel, bodyText }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      headline={t('reboot.notSavedModal.title')}
      bodyText={bodyText ?? t('reboot.notSavedModal.body')}
      onClose={onCancel}
      show={true}
      buttons={[
        { label: t('general.cancel'), onClick: onCancel },
        { label: t('general.reboot'), variant: 'danger', onClick: onReboot },
        { label: t('general.saveReboot'), variant: 'primary', onClick: onSave },
      ]}
    />
  );
};
